import $ from 'jquery';
import highlight from 'highlight.js';
import { iconSVG } from './tools/utils';


const ESCAPE_MAP = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	'\'': '&#039;',
};
const HIDDEN_CLASS = 'is-hidden';

const escapeHtml = (html) => html.replace(/[&<>"']/g, (char) => ESCAPE_MAP[char]);

const buildCodeSnippet = ($item) => {
	const $code = $item.find('.sg-box__item-code');

	if (!$code.length) return;

	const $annot = $item.find('.sg-box__item-annot');
	const codeHtml = escapeHtml($code.html());
	const codeLines = codeHtml.split(/\n/);
	const firstLineCode = codeLines[1];
	const tabsCount = firstLineCode.split(/[^\t]/)[0].length;
	const regex = new RegExp('^\t{'+ tabsCount+'}', 'mg');
	const trimmedHtml = $.trim(codeHtml.replace(regex, ''));
	const html = `
		<div class="sg-box__item-example sg-box__item-example--code sg-code is-hidden">
			<div class="sg-code__annot">
				<h3 class="sg-code__title">${iconSVG('code')} Ukázka HTML kódu</h3>
				<a href="#" class="sg-code__close">
					${iconSVG('close')}
				</a>
			</div>
			<div class="sg-code__content sg-code__content--code">
				<pre>
					<code class="html">${trimmedHtml}</code>
				</pre>
			</div>
		</div>
	`;
	const toggleHtml = `
		<a href="#" class="sg-box__item-toggle sg-box__item-toggle--code" title="Zdrojový kód">
			${iconSVG('code')}
		</a>
	`;

	$annot
		.append(toggleHtml)
		.after(html);

	$($item).find('.sg-box__item-toggle--code').on('click', (event) => {
		event.preventDefault();

		$item.find('.sg-box__item-example--code').toggleClass(HIDDEN_CLASS);
	});
};

const buildComment = ($item) => {
	const $comment = $item.find('.sg-box__item-comment');

	if (!$comment.length) return;

	const $annot = $item.find('.sg-box__item-annot');
	const comment = $comment.html();
	const html = `
		<div class="sg-box__item-example sg-box__item-example--comment sg-code">
			<div class="sg-code__annot">
				<h3 class="sg-code__title">${iconSVG('comment')} Popis komponenty</h3>
				<a href="#" class="sg-code__close">
					${iconSVG('close')}
				</a>
			</div>
			<div class="sg-code__content sg-code__content--comment">
				${comment}
			</div>
		</div>
	`;
	const toggleHtml = `
		<a href="#" class="sg-box__item-toggle sg-box__item-toggle--comment" title="Komentář">
			${iconSVG('comment')}
		</a>
	`;

	$annot
		.append(toggleHtml)
		.after(html);

	$item.find('.sg-box__item-toggle--comment').on('click', (event) => {
		event.preventDefault();

		$item.find('.sg-box__item-example--comment').toggleClass(HIDDEN_CLASS);
	});
};

const init = (index, item) => {
	const $this = $(item);

	buildCodeSnippet($this);
	buildComment($this);

	$(document).on('click', '.sg-code__close', (event) => {
		event.preventDefault();

		$(event.currentTarget).parents('.sg-box__item-example').addClass(HIDDEN_CLASS);
	});
};


const $item = $('.sg-box__item');

$item.each(init);

highlight.initHighlightingOnLoad();



// WEBPACK FOOTER //
// ./src/js/style-guide.js